<script lang="ts">
  import { toHeaderCase } from 'js-convert-case';
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import { isUrl, middleEllipsis, parseDynamicData } from '$shared/helpers/utils';
  import { EmptyLabelDefault } from '$provider/constants/global';
  import ObjectListAlert from './partials/ObjectListAlert.svelte';

  interface Props {
    alert: DataListAlert;
    onevent?: (payload: any) => void;
  }

  let { alert, onevent }: Props = $props();
</script>

<div data-cy="alert-list" class="list-alert" class:removed={alert?.removed}>
  <div class="label-wrap">
    {#if alert?.icon}
      <div class="icon"><Icon value={alert.icon} /></div>
    {/if}
    {#if alert?.label || alert?.key}
      <div data-cy={`${alert?.key || alert.label}-alert-k`} class="label">
        {alert?.key ? alert.key : toHeaderCase(alert.label)}
      </div>
    {/if}
  </div>
  {#if alert?.component}
    <alert.component {...alert.props} {onevent} />
  {:else if alert?.value && typeof alert?.value === 'object'}
    <ObjectListAlert value={alert?.value} />
  {:else}
    <div data-cy={`${alert?.key || alert.label}-alert-v`} class="value">
      {#if isUrl(alert?.value)}
        <a class="link" href={alert?.value} target="_blank" title={alert?.value}>
          {middleEllipsis(alert?.value, 40)}
        </a>
      {:else}
        {parseDynamicData(alert?.value) || EmptyLabelDefault}
      {/if}
    </div>
  {/if}
</div>

<style>
  .list-alert {
    background-color: var(--yellow);
    min-height: 44px;
    display: flex;
    align-items: flex-start;
  }
  .list-alert.removed {
    background-color: var(--red-light);
  }
  .label-wrap {
    display: flex;
    align-items: center;
    width: calc(150px + 16px);
    flex-shrink: 0;
    padding: 12px 16px;
  }
  .icon {
    margin-right: 8px;
    display: flex;
    align-items: center;
  }
  .label {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    display: flex;
  }
  .value {
    width: 100%;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: vae(--grey-medium);
    padding: 12px 16px;
  }
  .link {
    color: var(--blue);
    text-decoration: none;
  }
</style>
